import type {
  NotificationMap,
  PhoneDetails,
} from '@bb/domain/dist/types/AppointmentConfig';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type ExternalDashboardNotificationsDTO = {
  notifications?: NotificationMap;
  email?: string;
  phone?: PhoneDetails[];
  deliveries?: {
    Email: boolean;
    'Must Call'?: boolean | undefined;
    'Text Message'?: boolean | undefined;
  };
  feedbackCollectedExternal?: boolean;
};

const getDashboardNotificationsForListing = async ({
  dashboardId,
  listingId,
}: {
  dashboardId: string;
  listingId: string;
}) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/listing/${listingId}/notifications`,
    method: 'get',
  };

  const { data } =
    await axios.request<ExternalDashboardNotificationsDTO>(config);

  if (
    data?.notifications?.['Feedback Collected'] &&
    data.feedbackCollectedExternal !== false
  ) {
    data.feedbackCollectedExternal = true;
  }

  return data;
};

export default getDashboardNotificationsForListing;
